import React from 'react'
import CloseIconWhite from 'assets/icons/close_white.png'
import HobnobModal from 'src/components/common/HobnobModalV2/HobnobModal'
import styles from './zazzle-introduction-page-modal.scss'
import PropTypes from 'prop-types'
import CommonFrame from 'src/containers/GlobalLayer/CommonFrame/CommonFrame'
import Button from 'src/components/common/Button'
import ZazzleAndHobnobLogo from 'src/components/common/ZazzleAndHobnobLogo/ZazzleAndHobnobLogo'
import Stars from 'src/assets/stars.png'
import zazzleIntroductionModalBg from 'src/assets/zazzle-introduction-modal-bg.png'
import zazzleIntroductionModalBgMobile from 'src/assets/zazzle-introduction-modal-bg-mobile.png'

const ZazzleIntroductionPageModal = ({
  show,
  onClose
}) => {
  const renderCloseIcon = (
    <div className={styles['close-icon']}>
      <img src={CloseIconWhite} width="14" alt="close" />
    </div>
  )

  const actionLayer = () => {
    return (
      <div className={styles['action-layer']}>
        <div className={styles['info-container']}>
          <ZazzleAndHobnobLogo
            logoContainerClassName={styles['logo']}
            zazzleLogoClassName={styles['zazzle-logo']}
          />

          <img src={Stars} className={styles['stars']} alt="" />
          <div className={styles['action-title']}>
            Now included with your purchase
          </div>
          <ul className={styles['info-list']}>
            <li className={styles['info-item']}>A free event site</li>
            <li className={styles['info-item']}>Trackable RSVPs</li>
            <li className={styles['info-item']}>Automated reminders</li>
            <li className={styles['info-item']}>Photo sharing</li>
            <li className={styles['info-item']}>Signup lists, and more!!</li>
          </ul>
        </div>

        <Button className={styles['action-button']} onClick={onClose}>
          Let’s go
        </Button>
      </div>
    )
  }

  const descLayer = (
    <div className={styles['desc-layer']} >
      <img className={styles['desc-layer-bg']} src={zazzleIntroductionModalBg} />
      <img className={styles['desc-layer-mobile-bg']} src={zazzleIntroductionModalBgMobile} />
    </div>
  )
  return (
    <HobnobModal
      visible={show}
      destroyOnClose
      maskClosable={false}
      fullModal
      onCancel={onClose}
      closeIcon={renderCloseIcon}
      mobileFullScreen
    >
      <CommonFrame actionLayer={actionLayer()} descLayer={descLayer} mobileFullScreen />
    </HobnobModal>
  )
}

ZazzleIntroductionPageModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func
}

export default ZazzleIntroductionPageModal
